module.exports = __webpack_public_path__ + "static/img/leave-management-mobile-app.db49a03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recent-works/leave-management-mobile-app.png
// module id = cqY2
// module chunks = 1